import React from 'react'
import { Outlet } from 'react-router-dom'

import ContentLayout from '@lyrahealth-inc/ui-core/lib/molecules/layouts/base/ContentLayout'

const ReconcilerRoutes: React.FC = () => {
  return (
    <div>
      <ContentLayout>
        <div style={{ marginTop: '50px' }}>
          <Outlet />
        </div>
      </ContentLayout>
    </div>
  )
}

export default ReconcilerRoutes
